import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { RestoreAccount } from './model';

import { CommonInvitationErrorsView } from 'portcall/acceptinvitation/invitationerrorsview';
import { ProfileAndLandingPageLinks } from 'portcall/acceptinvitation/invitationlinks';
import { LoginView } from 'portcall/login/view';

export const RestoreAccountView = SuperCritical(({ model: m } : { model : RestoreAccount }) =>
    <div className="restoreaccount pc-page-fixedwidth">
        {m.Request.Response() ?
            <div className="pc-card restoreaccount-container">
                {m.Request.Response()!.Success ?
                    <RestoreAccountSuccess model={m} /> :
                    <CommonInvitationErrorsView model={m}
                        getError={key => m.Validation()[key]}
                        tokenErrorText="If you've already restored your account, try logging in." />
                }
            </div> :
            null // TH TODO -- loadingindicator
        }
        <LoginView modelContainer={m.Login} />
    </div>
);

let RestoreAccountSuccess = SuperCritical(({ model: m } : { model : RestoreAccount }) =>
    <div>
        <div className="result-description">
            Congratulations! Your account has been restored.
        </div>
        <ProfileAndLandingPageLinks model={m} />
    </div>
);


// WEBPACK FOOTER //
// ./apps/portcall/restoreaccount/view.tsx